import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      },
      {
        path: '/accounts',
        name: 'accounts',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Accounts.vue')
      },
      {
        path: '/churches',
        name: 'churches',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Churches.vue')
      },
      {
        path: '/members',
        name: 'members',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Members.vue')
      },
      {
        path: '/inquiries',
        name: 'inquiries',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Inquiries.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
